app.controller("ResetController", ["$scope", "AuthService",
    function ($scope, AuthService) {
        $scope.status = null;

        $scope.submit = function () {
            if ($scope.email) {
                AuthService.reset({email: $scope.email}).then(function (data) {
                    $scope.status = 'success';
                }).catch(function (err) {
                    console.error(err);
                    if (err.status === 400) {
                        $scope.status = 'no_such_email';
                    } else {
                        $scope.status = 'error';
                    }
                })
            }
        }
    }
]);